export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="inner footer-inner">
        <img
          src="/assets/images/logo-nova-white.png"
          alt="Nova"
          width="2272"
          height="657"
          className="footer-logo"
          loading="lazy"
        />

        <hr className="footer-divider" />

        <p className="footer-copy">
          © {new Date().getFullYear()} PlainBit. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
